<template>
  <v-app-bar id="app-bar" :elevation="4" class="app-bar">
    <template #prepend>
      <v-app-bar-nav-icon
        class="nav-icon"
        :ripple="false"
        @click="$emit('toggle-drawer')"
      ></v-app-bar-nav-icon>
    </template>

    <v-app-bar-title class="app-title">
      <span class="title-text">Brenden Runion</span>
    </v-app-bar-title>

    <template #append>
      <div class="d-flex align-center pr-1 pr-sm-4">
        <v-btn
          :icon="themeIcon"
          class="theme-toggle"
          variant="text"
          :ripple="false"
          @click="toggleTheme"
        />
      </div>
    </template>
  </v-app-bar>
</template>

<script>
import { useTheme } from 'vuetify';

export default {
  name: 'core-bar',
  emits: ['toggle-drawer'],
  setup() {
    const theme = useTheme();

    // Restore saved theme on component mount
    const savedTheme = localStorage.getItem('theme') || 'light';
    theme.global.name.value = savedTheme;

    return { theme };
  },
  data() {
    return {
      // Navigation items moved to drawer
    };
  },
  computed: {
    isDark() {
      return this.theme.global.name.value === 'dark';
    },
    themeIcon() {
      return this.isDark ? 'mdi-weather-night' : 'mdi-weather-sunny';
    },
  },
  methods: {
    toggleTheme() {
      const newTheme = this.isDark ? 'light' : 'dark';
      this.theme.global.name.value = newTheme;
      localStorage.setItem('theme', newTheme);
    },
  },
};
</script>

<style scoped>
.app-bar {
  /* The gradient below replaces the bg-primary class, so the on-primary text
     color it used to bring has to be set here too. */
  color: rgb(var(--v-theme-on-primary)) !important;
  background: linear-gradient(
    135deg,
    rgb(var(--v-theme-primary)) 0%,
    rgba(var(--v-theme-primary), 0.9) 100%
  ) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(var(--v-theme-primary), 0.3) !important;
}

.app-title {
  flex-grow: 1;
  text-align: center;
}

.title-text {
  font-size: var(--font-app-title) !important;
  font-weight: 700 !important;
  white-space: nowrap;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.title-text:hover {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transform: scale(1.02);
}

.nav-icon {
  color: white !important;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.nav-icon:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.theme-toggle {
  color: white !important;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.theme-toggle:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Enhanced primary color styling */
.app-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 70%
  );
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.app-bar:hover::before {
  opacity: 1;
}

/* Light/Dark theme adjustments */
.theme--light .app-bar {
  background: linear-gradient(
    135deg,
    rgb(var(--v-theme-primary)) 0%,
    rgba(var(--v-theme-primary), 0.95) 100%
  ) !important;
}

.theme--dark .app-bar {
  background: linear-gradient(
    135deg,
    rgb(var(--v-theme-primary)) 0%,
    rgba(var(--v-theme-primary), 0.85) 100%
  ) !important;
}
</style>
